import React from 'react';

function Privacy() {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-3xl mx-auto px-4 py-12 md:py-16">
        <h1 className="text-3xl md:text-4xl font-bold mb-8 text-gray-900">
          Integritetspolicy
        </h1>
        
        <div className="bg-white rounded-2xl p-6 md:p-8 shadow-sm space-y-6">
          <section>
            <h2 className="text-xl font-semibold mb-4 text-gray-900">Personuppgiftsansvarig</h2>
            <p className="text-gray-600 leading-relaxed">
              Utlysningslabbet är personuppgiftsansvarig för behandlingen av dina personuppgifter på denna webbplats.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4 text-gray-900">Rättslig grund för behandling</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              Vi behandlar dina personuppgifter med följande rättsliga grunder enligt GDPR:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-600">
              <li>Samtycke (Artikel 6.1.a) - När du registrerar dig på väntelistan eller skickar feedback</li>
              <li>Berättigat intresse (Artikel 6.1.f) - För att förbättra vår webbplats och tjänster</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4 text-gray-900">Information vi samlar in</h2>
            <div className="space-y-4">
              <div>
                <h3 className="font-medium text-gray-800 mb-2">Personuppgifter du delar med oss:</h3>
                <ul className="list-disc list-inside space-y-1 text-gray-600">
                  <li>E-postadress (när du registrerar dig på väntelistan)</li>
                  <li>Roll/position (när du lämnar feedback)</li>
                  <li>Feedback och kommentarer (när du använder feedbackformuläret)</li>
                </ul>
              </div>
              <div>
                <h3 className="font-medium text-gray-800 mb-2">Automatiskt insamlad information:</h3>
                <ul className="list-disc list-inside space-y-1 text-gray-600">
                  <li>Anonymiserad användningsstatistik via Plausible Analytics</li>
                  <li>Teknisk information som webbläsartyp och enhet (anonymiserat)</li>
                </ul>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4 text-gray-900">Hur vi använder informationen</h2>
            <ul className="list-disc list-inside space-y-2 text-gray-600">
              <li>För att kommunicera utvecklingsuppdateringar om Utlysningslabbet</li>
              <li>För att förbättra och anpassa tjänsten baserat på feedback</li>
              <li>För att analysera användningen av webbplatsen genom anonymiserad statistik</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4 text-gray-900">Lagringstid</h2>
            <p className="text-gray-600 leading-relaxed">
              Vi behåller dina personuppgifter endast så länge det är nödvändigt för de ändamål som beskrivs i denna policy eller tills du begär att få dem raderade. För väntelistan betyder detta tills tjänsten lanseras eller tills du begär att bli borttagen.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4 text-gray-900">Överföring av personuppgifter</h2>
            <p className="text-gray-600 leading-relaxed">
              Vi använder följande underleverantörer för behandling av personuppgifter:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-600 mt-2">
              <li>Supabase (databashantering) - lagrar data inom EU</li>
              <li>Plausible Analytics (anonym statistik) - lagrar data inom EU</li>
            </ul>
            <p className="text-gray-600 leading-relaxed mt-4">
              Vi överför inte dina personuppgifter utanför EU/EES-området.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4 text-gray-900">Cookies och spårning</h2>
            <p className="text-gray-600 leading-relaxed">
              Vi använder Plausible Analytics för anonym användningsstatistik. Detta verktyg:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-600 mt-2">
              <li>Använder inga cookies</li>
              <li>Samlar inte in personlig information</li>
              <li>Spårar inte användare mellan webbplatser</li>
              <li>Följer inte användarbeteende över tid</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4 text-gray-900">Dina rättigheter enligt GDPR</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              Som registrerad har du följande rättigheter:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-600">
              <li>Rätt till tillgång (Artikel 15) - Få information om vilka personuppgifter vi har om dig</li>
              <li>Rätt till rättelse (Artikel 16) - Få felaktiga uppgifter korrigerade</li>
              <li>Rätt till radering (Artikel 17) - Få dina uppgifter raderade</li>
              <li>Rätt till dataportabilitet (Artikel 20) - Få ut dina uppgifter i ett strukturerat format</li>
              <li>Rätt att göra invändningar (Artikel 21) - Invända mot viss typ av behandling</li>
              <li>Rätt att återkalla samtycke - Avregistrera dig från väntelistan när som helst</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4 text-gray-900">Klagomål till tillsynsmyndighet</h2>
            <p className="text-gray-600 leading-relaxed">
              Om du anser att vår behandling av dina personuppgifter strider mot dataskyddsförordningen har du rätt att lämna klagomål till Integritetsskyddsmyndigheten (IMY), som är tillsynsmyndighet i Sverige.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4 text-gray-900">Kontakta oss</h2>
            <p className="text-gray-600 leading-relaxed">
              För att utöva dina rättigheter eller om du har frågor om vår behandling av dina personuppgifter, vänligen kontakta oss via feedbackformuläret på webbplatsen. Vi kommer att besvara din förfrågan så snart som möjligt och senast inom en månad.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4 text-gray-900">Ändringar i integritetspolicyn</h2>
            <p className="text-gray-600 leading-relaxed">
              Vi kan komma att uppdatera denna integritetspolicy. Väsentliga ändringar kommer att kommuniceras via e-post till personer på väntelistan och genom ett meddelande på vår webbplats minst 30 dagar innan ändringarna träder i kraft.
            </p>
            <p className="text-sm text-gray-500 mt-4">
              Senast uppdaterad: {new Date().toLocaleDateString('sv-SE')}
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default Privacy;